<template>
    <div class="task-list-list" v-if="listContentShow==2" :class="showBatchDel?'delete-show':'delete-hide'">
        <el-table ref="multipleTable" border stripe :data="tasklistData" row-key="id" tooltip-effect="dark" style="width: 100%;" @row-click="clickRow" @selection-change="deleteHandleSelectionChange" @header-dragend="onHeaderDragEnd" :cell-class-name="cellClassName" :header-cell-class-name="cellClassName">
            <el-table-column type="selection" width="20"></el-table-column>
            <el-table-column :label="$t('language.common.taskName')" min-width="230">
                <template slot-scope="scope">
                    <div class="table-cell table-cell-name" v-if="isFlag!=scope.$index" @click="editTaskListName(scope.row,scope.$index)" :title="scope.row.name">{{scope.row.name}}</div>
                    <el-input ref="listInputName" v-if="isFlag==scope.$index" :disabled="isFlag!=scope.$index" class="table-card-edit" type="textarea" :autosize="{minRows:1,maxRows:2}" resize="none" v-model="changeNameTemp" @blur="submitTaskListName(scope.row)" @keydown.enter.native="enterEvent(scope.row,$event)"></el-input>
                </template>
            </el-table-column>
            <el-table-column :label="$t('language.common.from')" min-width="280">
                <template slot-scope="scope">
                    <div class="list-route-item" v-if="scope.row.fromItem">
                        <div class="task-icon-multi" v-if="scope.row.fromItem.icons.length>1" style="float: left;" @click.stop="openFunctionPopup(8,scope.row)">
                            <!-- 多源图标拼接 -->
                            <div class="clouds_logo clouds_logo_20" v-for="(fromItem,index) in scope.row.fromItem.icons.slice(0, 4)" :key="index" :class="fromItem.driveType" :style="(scope.row.fromItem.icons.length==3&&index==0)?'margin: 0 10px;':''"></div>
                            <div v-if="scope.row.fromItem.icons.length>4&&scope.row.fromItem.icons.length<10" class="task-icon-multi-more">{{scope.row.fromItem.icons.length}}</div>
                            <div v-if="scope.row.fromItem.icons.length>9" class="task-icon-multi-more">9+</div>
                        </div>
                        <!-- 多源单云盘 -->
                        <div class="clouds_logo clouds_logo_40" :class="scope.row.fromItem.icons[0].driveType" v-else style="float: left;" @click.stop="toSourceCatalog(scope.row)"></div>
                        <div class="table-cell">
                            <span v-if="scope.row.fromItem.icons.length>1" @click.stop="openFunctionPopup(8,scope.row)">{{$t('language.taskList.multiClouds')}}</span>
                            <span v-else>
                                <span v-if="scope.row.fromItem.lists[0].driveType == 'offlinesTask'" @click.stop="copyLink(scope.row.fromItem.lists[0].name)">
                                    {{$t('language.common.copyLink')}}
                                </span>
                                <span v-else @click.stop="toSourceCatalog(scope.row)" :title="getNewCloudName(scope.row.fromItem.lists[0])">{{getNewCloudName(scope.row.fromItem.lists[0])}}</span>
                            </span>
                            
                        </div>
                    </div>
                    <!-- <div class="list-route-item" v-else @click.stop="toSourceCatalog(scope.row)">
                        <div class="clouds_logo" :class="scope.row.fromItem.driveType" style="float: left;"></div>
                        <div class="table-cell" :title="scope.row.fromItem.nodes|getCatalog|getCatalogTitle">{{scope.row.fromItem.nodes[scope.row.fromItem.nodes.length-1]|getItemName}}</div>
                    </div> -->
                </template>
            </el-table-column>
            <el-table-column :label="$t('language.common.to')" min-width="280">
                <template slot-scope="scope">
                    <div class="list-route-item" v-if="scope.row.toItem">
                        <div class="task-icon-multi" v-if="scope.row.toItem.icons.length>1" style="float: left;" @click.stop="openFunctionPopup(8,scope.row)">
                            <!-- 多源图标拼接 -->
                            <div class="clouds_logo clouds_logo_20" v-for="(toItem,index) in scope.row.toItem.icons.slice(0, 4)" :key="index" :class="toItem.driveType" :style="(scope.row.toItem.icons.length==3&&index==0)?'margin: 0 10px;':''"></div>
                            <div v-if="scope.row.toItem.icons.length>4&&scope.row.toItem.icons.length<10" class="task-icon-multi-more">{{scope.row.toItem.icons.length}}</div>
                            <div v-if="scope.row.toItem.icons.length>9" class="task-icon-multi-more">9+</div>
                        </div>
                        <!-- 多源单云盘 -->
                        <div class="clouds_logo clouds_logo_40" :class="scope.row.toItem.icons[0].driveType" v-else style="float: left;" @click.stop="toAimCatalog(scope.row)"></div>
                        <div class="table-cell">
                            <span v-if="scope.row.toItem.icons.length>1" @click.stop="openFunctionPopup(8,scope.row)">{{$t('language.taskList.multiClouds')}}</span>
                            <span v-else @click.stop="toAimCatalog(scope.row)">
                                <span v-if="scope.row.type==6&&(scope.row.tranferWay=='restore'||scope.row.tranferWay=='retry-restore')&&(scope.row.status==1||scope.row.status==2)&&(!scope.row.isRestoreNew)">
                                    {{$t('language.cloudBackup.original')}}
                                </span>
                                <span v-else :title="getNewCloudName(scope.row.toItem.lists[0])">{{getNewCloudName(scope.row.toItem.lists[0])}}</span>
                            </span></div>
                    </div>
                    <!-- <div class="list-route-item" v-else @click.stop="toAimCatalog(scope.row)">
                        <div class="clouds_logo" :class="scope.row.toItem.driveType" style="float: left;"></div>
                        <div class="table-cell" :title="scope.row.toItem.nodes|getCatalog|getCatalogTitle">{{scope.row.toItem.nodes[scope.row.toItem.nodes.length-1]|getItemName}}</div>
                    </div> -->
                </template>
            </el-table-column>
            <el-table-column :label="$t('language.common.schedule')" min-width="220">
                <template slot-scope="scope">
                    <div v-if="scope.row.schedules">
                        <div class="" v-if="isShowSchdule(scope.row)">
                            <tabTaskSchdule ref="tabTaskSchdule" :task="scope.row" @update="clickScheduleBtn" @open-popup="openFunctionPopup"></tabTaskSchdule>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column :label="$t('language.common.status')" min-width="220">
                <template slot-scope="scope">
                    <!-- 任务状态 -->
                    <div class="list-state">
                        <!-- 显示任务状态 -->
                        <tabTaskStatus ref="tabTaskStatus" :task="scope.row" :progress="progress" @open-popup="openFunctionPopup"></tabTaskStatus>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="" min-width="220">
                <template slot-scope="scope">
                    <!-- 任务功能-->
                    <div class="list-btns" @mouseleave="changeOptionMenu(false)">
                        <!-- 显示任务功能 -->
                        <tabTaskOption ref="tabTaskOption" :task="scope.row" @open-popup="openFunctionPopup" @update="clickButton"></tabTaskOption>
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import taskListSingelJS from "@/js/workspace/task_list_singel.js";
import commonUtils from "@/js/workspace/common_util.js";
import taskListUtils from "@/js/workspace/task_list_util.js";

//任务定时，状态和功能
import tabTaskSchdule from "@/components/common/tabs/tabs_task_list/tab_task_schdule";
import tabTaskStatus from "@/components/common/tabs/tabs_task_list/tab_task_status";
import tabTaskOption from "@/components/common/tabs/tabs_task_list/tab_task_option";

export default ({
    name: "taskListFormTab",
    props: ['tasklistData','listContentShow','showBatchDel','checkDeleteList', 'progress'],
    data: function() {
        return {
            threadChange: false, //用于子组件渲染界面
            hoverCurrent: -1,
            clickCurrent: -1,
            operateMenuIndex: -1,
            unfinishedArr: ["Cancel", "cancel", "error"],
            pathJson: [],
            menuTop: 35,
            taskListMenuTop: 32,
            executeFlag: true,
            taskUpTxt: 'cloudTransfer', //显示右上角的文案
            buttonTxt: this.$t('language.cloudTransfer.transferNow'), //用于显示按钮上的文字
            statusTxt: '', //显示单个任务的状态文案
            iconName: null,
            transferDetailChange: false, //用于子组件渲染界面
            refreshFlag: true, //标识是否刷新界面
            switchTypeFlag: true,
            openRestoreFlag: true, //标识是否打开还原界面
            user: commonUtils.getUser(),
            isOpenMenu: false,
            schedulesStatus: [],
            otherDelList: [],//其他页面选中参数，更换源时更新
            changeNameTemp: '',// 保存将要修改的任务名称
            isFlag: -1,// 正在修改的任务序号
        }
    },
    components: {
        tabTaskSchdule,
        tabTaskStatus,
        tabTaskOption,
    },
    methods: {
        // 获取源云盘或目标云盘名称，用于显示name
        getNewCloudName(item) {
            if(item.driveId) {
                // 如果有云盘id，则去获取云盘名称
                var driveName = null;
                var drives = this.$store.getters.getUsersDrives;
                for (var i=0; i<drives.length; i++) {
                    if (drives[i].id == item.driveId) {
                        driveName = drives[i].name;
                        break;
                    }
                }
                return driveName;
            }else {
                return item.name;
            }
        },
        // 链接复制功能
        copyLink(url) {
            let oInput = document.createElement('input');
            oInput.value = url;
            document.body.appendChild(oInput);
            oInput.select(); // 选择对象;
            document.execCommand("Copy"); // 执行浏览器复制命令
            this.$toast({
                text: this.$t('language.popup.cloudExploerPopup.linkCopySuccessful'),
                type: 'success',
                idValue: "rightBodyList",
            });
            oInput.remove();
        },
        //选中行
        clickRow(row) {
            if(this.showBatchDel) {
                this.$refs.multipleTable.toggleRowSelection(row);
            }
        },
        //打开功能弹窗
        openFunctionPopup(type,task) {
            console.log(type,task)
            //打开弹窗
            this.$emit("open-function-popup",type,task);
            this.isOpenMenu = false;
        },
        //点击最右边按钮
        clickButton(type,task,callback) {
            console.log(type)
            if(type == 0) {
                //type==0 关闭
                this.$emit("pause-task",task,() => {
                    callback();
                });
            }else if(type == 1) {
                //type==1 运行
                this.$emit("execute-task",task,() => {
                    callback();
                });
                return;
            }
        },
        //是否显示定时按钮
        isShowSchdule(item) {
            if(item.lowerType==105||(item.lowerType==102&&item.branchType=='realtime')) {
                return false;
            }else {
                return true;
            }
        },
        clickScheduleBtn(item,index) {
            taskListSingelJS.clickScheduleBtn(this,item,index);
        },
        //列表样式相关
        cellClassName({row, column, rowIndex, columnIndex}) {
            if(columnIndex==0){
                return 'select-cell';
            }
        },
        //列表选择需要删除的任务
        deleteHandleSelectionChange(val) {
            console.log('val',val)
            if(val&&val.length>0){
                //合并集合并去重
                const nowList = val.map((task) => {return task&&task.id});
                this.$parent.checkDeleteList = [...this.otherDelList, ...nowList];
            }else {
                //判断之前是否有选中，如果没有则无需变更
                //移除集合取差集
                this.$parent.checkDeleteList = [...this.checkDeleteList].filter(x => [...this.tasklistData].every(y => y.id != x));
            }
        },
        //控制功能菜单状态
        changeOptionMenu(type) {
            this.isOpenMenu = type;
        },
        toSourceCatalog(item) {
            if(item.fromItem.lists[0].driveType == 'offlinesTask') {
                return;
            }
            if(item.fromItem.lists.length > 1) {
                //多源
                this.openFunctionPopup(8);
            }else {
                this.$parent.toSourceCatalog(item.fromItem.lists[0],item.taskType);
            }
        },
        toAimCatalog(item) {
            if(item.toItem.lists.length > 1) {
                //多目标
                this.openFunctionPopup(8);
            }else {
                this.$parent.toAimCatalog(item.toItem.lists[0],item.taskType);
            }
        },
        //开启修改任务名输入框
        editTaskListName(item,index) {
            if(item.lowerType == 105)return;
            this.changeNameTemp = item.name;
            this.isFlag = index;
            this.$nextTick(() => {
                this.$refs.listInputName.select();
            });
        },
        enterEvent(item,event) {
            if(!event.ctrlKey) {
                event.preventDefault();
                this.submitTaskListName(item);
            }else {
                this.changeNameTemp += '\n';
            }
        },
        //关闭并还原修改任务名输入框
        cancelUpdateTaskName(item) {
            this.changeNameTemp = "";
            this.isFlag = -1;
        },
        //提交任务名
        submitTaskListName(item) {
            var inputValue = this.changeNameTemp.trim();
            if(inputValue && inputValue != item.name) {
                if (inputValue.length > 255) {
                    this.$toast({
                        text: this.$t('language.taskList.taskNameRule'),
                        type: 'fail',
                        idValue: "rightBodyList"
                    });
                    this.cancelUpdateTaskName(item);
                    return false;
                }

                //禁用输入框
                this.isFlag = -1;

                if (item.branchType == "businessTransfer") {
                    this.updateBusinessTask(item);
                    return;
                }

                var updateData;
                if (item.isMultiTask) {
                    updateData = new taskListUtils.updateGdData(item.id, commonUtils.getUser().id, item.type, inputValue,null, null);
                } else {
                    updateData = new taskListUtils.updateIdData(item.id, commonUtils.getUser().id, item.type, inputValue,null, null);
                }
                this.Utils.doTasksRequest("update", updateData).then(result => {
                    if (result.status == 200) {
                    //成功修改名称
                    item.name = inputValue;
                    this.cancelUpdateTaskName(item);
                    } else {
                    //未成功修改名称,退回名称
                    this.cancelUpdateTaskName(item);
                    this.$toast({
                        text: this.$t('language.exception.' + result.reason),
                        type: 'fail',
                        idValue: "rightBodyList"
                    });
                    }
                });
            } else {
                this.cancelUpdateTaskName(item);
            }
        },
        //提交重命名的任务名
        updateBusinessTask(item) {
            var updateData = {
                n: this.changeNameTemp,
                id: item.id,
                ud: commonUtils.getUser().id
            }
            this.Utils.doBusinessTransferRequest("update", updateData).then(data => {
                item.name = this.changeNameTemp;
                this.cancelUpdateTaskName(item);
            }).catch(err => {
                if (err.reason) {
                    err = that.$t('language.exception.' + err.reason)
                }
                this.cancelUpdateTaskName(item);
                this.$toast({
                    text: err,
                    type: 'fail',
                    idValue: "rightBodyList"
                });
            });
            
        },
        //监听列宽不得低于文本宽度
        onHeaderDragEnd(newWidth, oldWidth, column, event) {
            // 假设你的列是基于element-ui的el-table-column
            const minWidth = 220;
            if (newWidth < minWidth) {
                // 如果拖动后的宽度低于最小宽度，重置为最小宽度
                column.width = minWidth;
            }
        },
    }
})
</script>

<style scoped>
/** 
    表格
*/

.task-list-list {
    margin-right: 45px;
    /*no*/
    height: calc(100% - 50px);
    /*no*/
    background-color: #fff;
    border: 1px solid #d6e4f7;
    /*no*/
}

.list-btns {
    float: left;
    display: flex;
    align-items: center;
    justify-content: center;
    visibility: hidden;
}

.list-route-item:hover {
    text-decoration: underline;
    cursor: pointer;
}

.list-route-item .task-icon-multi {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    /*no*/
    height: 40px;
    /*no*/
    flex-wrap: wrap;
    position: relative;
}

.list-route-item .task-icon-multi-more {
    position: absolute;
    width: 15px;
    /*no*/
    height: 15px;
    /*no*/
    background-color: #5562B4;
    border-radius: 15px;
    /*no*/
    border: 1.33px solid rgba(255, 255, 255, 0.6);;
    /*no*/
    color: #ffffff;
    font-size: 9px;
    /*no*/
    font-weight: 500;
    line-height: 15px;
    /*no*/
    text-align: center;
}

.task-list-list >>>.el-table__row:hover .list-btns {
    visibility: unset;
}

.delete-hide >>>.select-cell .el-checkbox {
    visibility: hidden;
}

.delete-show >>>.el-table__row .el-table__cell .cell{
    pointer-events: none;
}

.task-list-list >>>.el-table-column--selection .cell {
    padding-left: 6px !important;
    /*no*/
}

.task-list-list >>>.el-table {
    font-family: Arial;
    font-size: 16px;
    /*no*/
    font-weight: normal;
    line-height: normal;
    letter-spacing: 0em;
    height: 100%;
}

.task-list-list >>>.el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell {
    background: #F9FBFE;
}

.task-list-list >>>.el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell {
    background: #F2F7FE;
}

.task-list-list >>>.el-table td.el-table__cell {
    border: none;
    height: 56px;
    /*no*/
    font-size: 14px;
    /*no*/
}

.task-list-list >>>.el-table th.el-table__cell.is-leaf {
    border-width: 0px 0px 1px 0px;
    /*no*/
    border-style: solid;
    border-color: #C1CBE3;
}

.task-list-list >>>.el-table__cell.gutter {
    border-width: 0px 0px 1px 0px;
    /*no*/
    border-style: solid;
    border-color: #C1CBE3;
    width: 8px !important;
}

.task-list-list >>>.el-table thead {
    color: #6F6F6F;
}

.task-list-list >>>.el-table thead th {
    font-weight: normal;
}

.task-list-list >>>.el-table tbody {
    overflow-y: scroll;
}

.task-list-list >>>.el-table__body-wrapper {
    height: calc(100% - 50px);
    overflow-y: auto;
}

.task-list-list >>>.el-table__body-wrapper::-webkit-scrollbar {
    width: 8Px;
    /*no*/
    height: 8Px;
    /*no*/
    background-color: transparent;
}

.task-list-list >>>.el-table__body-wrapper::-webkit-scrollbar-thumb {
    height: 1Px;
    /*no*/
    border-radius: 5Px;
    /*no*/
    background-color: #becae4;
}

.task-list-list >>>.el-table__body-wrapper::-webkit-scrollbar-track {
    background-color: transparent;
}

.task-list-list >>>.el-table td .cloud {
    width: 84px;
    /*no*/
}

.task-list-list >>>.el-table tbody td .cloud.iCloudPhotos {
    background-position: -436px -240px;
}

.task-list-list >>>.el-table tbody td .table-cell {
    padding-right: 30px;
    /*no*/
    font-size: 14px;
    /*no*/
    line-height: 42px;
    /*no*/
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.task-list-list >>>.el-table .table-cell-name {
    font-weight: bold;
}

</style>


// WEBPACK FOOTER //
// src/components/common/tabs/tabs_task_list/tabs_single_task_form.vue